import { CSSProperties } from '@vanilla-extract/css';
import { fontSizes, fontWeight, lineHeights } from './tokens';

export const typography = {
  displayLg: {
    fontWeight: fontWeight.regular,
    fontSize: fontSizes.displayLg,
    lineHeight: lineHeights.tight,
    letterSpacing: '0.01em',
  },
  displayMd: {
    fontWeight: fontWeight.regular,
    fontSize: fontSizes.displayMd,
    lineHeight: lineHeights.tight,
    letterSpacing: '0.01em',
  },
  displaySm: {
    fontWeight: fontWeight.medium,
    fontSize: fontSizes.displaySm,
    lineHeight: 1.35,
    letterSpacing: '0.01em',
  },

  headlineLg: {
    fontWeight: fontWeight.bold,
    fontSize: fontSizes.headlineLg,
    lineHeight: lineHeights.snug,
    letterSpacing: '0.01em',
  },
  headlineMd: {
    fontWeight: fontWeight.bold,
    fontSize: fontSizes.headlineMd,
    lineHeight: lineHeights.snug,
    letterSpacing: '0.01em',
  },
  headlineSm: {
    fontWeight: fontWeight.bold,
    fontSize: fontSizes.headlineSm,
    lineHeight: lineHeights.snug,
    letterSpacing: '0.01em',
  },

  titleLg: {
    fontWeight: fontWeight.bold,
    fontSize: fontSizes.titleLg,
    lineHeight: lineHeights.snug,
    letterSpacing: '-0.02em',
  },
  titleMd: {
    fontWeight: fontWeight.bold,
    fontSize: fontSizes.titleMd,
    lineHeight: lineHeights.snug,
    letterSpacing: '-0.02em',
  },
  titleSm: {
    fontWeight: fontWeight.bold,
    fontSize: fontSizes.titleSm,
    lineHeight: lineHeights.snug,
    letterSpacing: '-0.02em',
  },

  bodyLg: {
    fontWeight: fontWeight.regular,
    fontSize: fontSizes.bodyLg,
    lineHeight: lineHeights.snug,
    letterSpacing: '-0.01em',
  },
  bodyMd: {
    fontWeight: fontWeight.regular,
    fontSize: fontSizes.bodyMd,
    lineHeight: lineHeights.snug,
    letterSpacing: '-0.01em',
  },
  bodySm: {
    fontWeight: fontWeight.regular,
    fontSize: fontSizes.bodySm,
    lineHeight: lineHeights.snug,
    letterSpacing: '-0.01em',
  },

  labelLg: {
    fontWeight: fontWeight.medium,
    fontSize: fontSizes.labelLg,
    lineHeight: lineHeights.snug,
    letterSpacing: '-0.01em',
  },
  labelMd: {
    fontWeight: fontWeight.medium,
    fontSize: fontSizes.labelMd,
    lineHeight: lineHeights.snug,
    letterSpacing: '-0.01em',
  },
  labelSm: {
    fontWeight: fontWeight.medium,
    fontSize: fontSizes.labelSm,
    lineHeight: lineHeights.snug,
    letterSpacing: '-0.01em',
  },
} satisfies Record<string, CSSProperties>;
